let w = window.innerWidth;
if (w < 991) {
    var swiper_full = new Swiper('.product-slider', {
        slidesPerView: "1",
        spaceBetween: 0,
        pagination: {
            el: '.product-pagination',
            clickable: true
        }
    });
}